import React, { useContext, useState, useMemo, useEffect, useRef } from 'react';
import { useQuery } from 'react-query';
import { Main } from '../../NecttosComp/Layout/Layout';
import { Table, Tbody, Td, Th, Thead, Tr } from '../../NecttosComp/Table/Table';
import { NecttosContext } from '../../context/NecttosContext';
import Button from '../../NecttosComp/Button/Button';
import Input2 from '../../NecttosComp/Input/Input2';
import toast from 'react-hot-toast';
import AdmissionVerificationProcess from './AdmissionVerificationProcess';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import Instruction from '../../Documentation/Instruction';
import { Grid } from 'react-loader-spinner';
import DeleteVerificationProcess from './DeleteVerificationProcess';
import Printercustompage from './Printercustom';
import notFoundProfile from '../../static/images/library/noPhotoAvailable.png';
import AddNewUsertoAdmission from './AddNewUsertoAdmission';
import { Modal } from 'react-bootstrap';
import AdmissionRegister3 from '../Admission/AdmissionRegister3';
import FeesBilling from '../Accounts/FeesBilling';
import HandleProceed from './HandleProceed';

const getAdmissionControlCentre = (collegeId, classId, userId, key, startDate, endingDate, newClassId) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/admissionProcess2/getAdmissionControlCentre', {
			params: {
				collegeId,
				classId,
				userId,
				key,
				startDate,
				endingDate,
				newClassId,
			},
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};
const getAdmittedStudents = (collegeId, filters) => async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/admissionProcess2/getAdmittedStudentsBatchWise', {
			params: {
				collegeId,
				...filters,
			},
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return Array.isArray(resp.data.data) ? resp.data.data : [];
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};
const getrejectUserFromVerification = async () => {
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/admissionProcess2/getrejectUserFromVerification');
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

function AdmissionControlCenter({ isTemp, onClose }) {
	const { college, role, collegeId, selectedCollege, userId, profile } = useContext(NecttosContext);
	const [keyData, setKeyData] = useState('department');
	const [searchTerm, setSearchTerm] = useState('');
	const [state, setState] = useState({});
	const [showFeesBilling, setShowFeesBilling] = useState(false);
	const [controlCenterDashboardModal, setControlCenterDashboardModal] = useState(false);
	const [Printercustom, setPrintercustom] = useState({
		visible: false,
		studentId: null,
		isTemp: false,
	});

	const [filters, setFilters] = useState(() => {
		const storedFilters = localStorage.getItem('filtersCourseWiseAdmission');
		return storedFilters ? JSON.parse(storedFilters) : { academicYear: '' };
	});

	useEffect(() => {
		localStorage.setItem('filtersCourseWise', JSON.stringify(filters));
	}, [filters]);

	const [itemsData, setItemsData] = useState({
		feesBilling: false,
		ptaVerification: false,
		keyDataIsStaff: true,
		studentId: '',
	});

	let classId = '';

	const { data, refetch, status } = useQuery(['getAdmissionControlCentre', collegeId, classId, userId, role, keyData], getAdmissionControlCentre(collegeId, classId, userId, keyData, role));
	const { data: admittedStudents } = useQuery(['getAdmittedStudents', collegeId, filters], getAdmittedStudents(collegeId, filters));

	// console.log('AdmissionControlCenter data:', admittedStudents);

	const getTimeExtended = async () => {
		const instance = await getAxiosTokenInstance();
		const resp = await instance.get('/college/admissionProcess2/gettimeextended');
		if (resp.data.statusCode === 400) throw new Error(resp.data.message);
		return resp.data;
	};
	const componentRef = useRef();

	const handleModalOpen = () => {
		setControlCenterDashboardModal(true);
	};
	const handleModalClose = () => {
		setControlCenterDashboardModal(false);
	};

	useEffect(() => {
		if (userId) {
			setItemsData((prev) => ({
				...prev,
				studentId: userList?._id,
			}));
		}
	}, [userId]);

	const { data: datareject, refetchreject, statusreject } = useQuery(['getrejectUserFromVerification', collegeId, classId, userId, role, keyData], getrejectUserFromVerification);

	const { data: datagivetime } = useQuery(['getTimeExtended'], getTimeExtended);

	const userList = keyData === 'rejected' ? datareject?.data : keyData === 'giveTimed' ? datagivetime?.data : data?.list || [];

	const filteredUserList = userList?.filter((user) => user?.name?.toLowerCase()?.includes(searchTerm.toLowerCase()));

	const verificationStages = selectedCollege?.verificationStages || [];
	const previousKeyMap = selectedCollege?.previousKeyMap || {};

	// const yearOfLatest = new Date().getFullYear();
	// const defaultDepartment= profile?.departmentIds[0]|| '';

	return (
		<>
			<Main width='100%' height='100%' title='Admission Control Center'>
				<div className='h-[80vh]'>
					<div className='flex gap-4'>
						<div className='fixed left-[1%] w-[15%]'>
							<div className='w-full max-h max-w-sm mx-auto flex-col rounded-xl shadow-md p-1 flex items-center space-x-4 my-3'>
								<img src={profile?.photoURL || notFoundProfile} alt='Profile' className='w-12 h-12 rounded-lg object-cover border-2 border-green-500' />
								<div className='flex-1'>
									<h2 className='text-lg text-center font-semibold text-gray-900 dark:text-white'>{profile?.name}</h2>
									<p className='text-sm text-center text-gray-600 dark:text-gray-300'>{profile?.shortName}</p>
								</div>
							</div>
							<div className='rounded-xl shadow-lg overflow-hidden border border-slate-200 dark:border-slate-700 dark:bg-slate-800'>
								<div className='bg-gradient-to-r from-blue-700 to-indigo-800 text-white text-center font-bold py-3 px-3 text-sm uppercase tracking-wide'>Admission Workflow</div>
								<div className='flex flex-col divide-y divide-gray-200 dark:divide-slate-700'>
									{verificationStages?.map((stage) => {
										if (!role.includes('nodal') && stage.keyData === 'nodal') return null;
										return (
											<div key={stage.keyName} onClick={() => setKeyData(stage.keyData)} className={`text-sm px-4 py-2 cursor-pointer transition-all duration-200 font-medium ${stage.keyData === keyData ? 'bg-blue-600 text-white' : 'text-gray-700 dark:text-slate-200 hover:bg-blue-100 dark:hover:bg-slate-700'}`}>
												{stage.title}
											</div>
										);
									})}
								</div>
							</div>
						</div>

						<div className='fixed ml-[15%] w-[84%] px-4 overflow-hidden h-[96vh]'>
							<div className='flex items-center justify-between w-full px-4 py-2'>
								<div className='flex items-center gap-2'></div>
								<div className='flex items-center'>
									<Input2 className='w-[40vw]' type='text' fieldName='search' placeholder='Search students...' setState={setSearchTerm} state={searchTerm} searchKey='name' />
									<Instruction keyId={'admissionControlCenter'} />
									{/* <Button type='print' tableRef={componentRef.current}>
										Print
									</Button> */}
									{/* <Button type='save' onClick={handleModalOpen}>
										Get Statistics
									</Button> */}
									<Button
										type='save'
										onClick={() =>
											setState({
												...state,
												addNewUsertoAdmission: true,
											})
										}>
										Add User
									</Button>
									<Button type='close' onClick={onClose}>
										Close
									</Button>
								</div>
							</div>
							<style>
								{`
									
								@media print {
	.no-print {
		display: none !important;
	}
	.page-break {
		page-break-after: always;
	}
	.page-break:last-child {
		page-break-after: auto;
	}
}`}
							</style>
							{keyData === 'admittedStudents' ? (
								<div>
									<div className='flex justify-between items-center no-print'>
										<Input2 fieldName='Filter Batches' returnKey='batchName' state={filters} setState={setFilters} options={['2024-2028', '2025-2029', '2025-2027']} type='drop' className='w-[10vw]' />
										<Button type='print' tableRef={componentRef.current} className='printable overflow-y-auto scrollable-container mb-3'>
											Print
										</Button>
									</div>
									<div
										style={{
											overflowY: 'auto',
											maxHeight: '100vh',
										}}>
										<div ref={componentRef} className='printable'>
											{admittedStudents?.map((classData, classIndex) => (
												<div key={classIndex} className={`flex flex-col justify-center items-center bg-white border border-gray-300 rounded-xl shadow-sm ${classIndex < admittedStudents.length - 1 ? 'page-break' : ''}`}>
													<div className='text-center flex justify-center items-center flex-col'>
														<img src={college?.logo || notFoundProfile} alt='Profile' className='w-12 h-12 rounded-lg object-cover border-2 border-gray-500' />
														<h2 className='text-lg font-semibold text-gray-800'>NECTTOS</h2>
														<p className='text-sm text-gray-600'>ADMITTED LIST</p>
														<p className='text-sm text-gray-600'>
															{classData?.longName} - {classData?.batchName}
														</p>
													</div>

													<Table height='100%' width='100%' className='rounded-lg shadow-md mb-10'>
														<Thead>
															<Tr className='bg-gray-100'>
																<Th width='6%' className='py-3 px-4'>
																	Sl.No
																</Th>
																<Th width='10%' className='py-3 px-4 '>
																	Admn No
																</Th>
																<Th width='34%' className='py-3 px-4 '>
																	Name
																</Th>
																<Th width='18%' className='py-3 px-4'>
																	CapId
																</Th>
																<Th width='12%' className='py-3 px-4 '>
																	Date of Admn
																</Th>
																<Th width='12%' className='py-3 px-4 '>
																	Admission Category
																</Th>
															</Tr>
														</Thead>
														<Tbody>
															{classData?.students?.map((user, index) => (
																<Tr key={user.id || user._id} className={`hover:bg-gray-50 border-b border-gray-200 ${data?.emergencyIndex > -1 ? 'bg-green-50 hover:bg-green-100' : ''}`}>
																	<Td width='6%' textAlign={'center'} className='py-3 px-4 '>
																		{index + 1}
																	</Td>
																	<Td width='10%' className='py-3 px-4 '>
																		{user?.admisionNo}
																	</Td>
																	<Td width='34%' className='py-3 px-4'>
																		{user?.name?.toUpperCase()}
																	</Td>
																	<Td width='18%' className='py-3 px-4 font-medium '>
																		{user?.capId?.toUpperCase()}
																	</Td>
																	<Td width='12%' className='py-3 px-4 '>
																		{user?.dateOfAdmission?.slice(0, 10) || 'N/A'}
																	</Td>
																	<Td width='12%' className='py-3 px-4 '>
																		{user?.admType?.slice(0, 10) || user?.admnType?.slice(0, 10)||'Not provided'}
																	</Td>
																</Tr>
															))}
														</Tbody>
													</Table>
												</div>
											))}
										</div>
									</div>
								</div>
							) : (
								<div ref={componentRef} className='printable overflow-y-auto'>
									<Table height='100%' width='100%' className='rounded-lg shadow-md overflow-hidden'>
										<Thead>
											<Tr className='bg-gray-100 fixed'>
												<Th width='3%' className='py-3 px-4'>
													Serial No
												</Th>
												<Th width='10%' className='py-3 px-4'>
													Application Status/Token
												</Th>
												<Th width='10%' className='py-3 px-4'>
													Created/Previous Time
												</Th>
												<Th width='10%' className='py-3 px-4'>
													Name
												</Th>
												<Th width='10%' className='py-3 px-4'>
													Mobile
												</Th>
												<Th width='10%' className='py-3 px-4'>
													{keyData === 'rejected' ? 'Delete' : 'Course'}
												</Th>
												<Th width='10%' className='py-3 px-4'>
													Verification
												</Th>
												<Th width='10%' className='py-3 px-4'>
													Print Form
												</Th>
											</Tr>
										</Thead>
										<Tbody>
											{status === 'loading' ? (
												<div className='m-5 p-5 flex justify-center items-center'>
													<Grid height={'250'} width='250' color='#0083f5' visible={status === 'loading'} />
												</div>
											) : (
												<div className='overflow-scroll h-[80vh]'>
													{filteredUserList?.length === 0 ? (
														<div className='m-5 p-6 flex justify-center items-center bg-green-50 dark:bg-green-900 border border-green-300 dark:border-green-700 rounded-xl shadow-sm'>
															<div className='text-center'>
																<svg className='mx-auto mb-3 h-8 w-8 text-green-600 dark:text-green-300' fill='none' stroke='currentColor' strokeWidth='2' viewBox='0 0 24 24'>
																	<path strokeLinecap='round' strokeLinejoin='round' d='M5 13l4 4L19 7' />
																</svg>
																<h2 className='text-lg font-semibold text-green-700 dark:text-green-200'>All Admissions Verified</h2>
																<p className='text-sm text-green-600 dark:text-green-300'>There are no pending verifications. Everything is up to date. Just refresh to ensure</p>
															</div>
														</div>
													) : (
														filteredUserList?.map((user, index) => (
															<Tr key={user.id || user._id} className={`hover:bg-gray-50 border-b border-gray-200 ${data?.emergencyIndex > -1 ? 'bg-green-50 hover:bg-green-100' : ''}`}>
																{' '}
																<Td width='5%' className='py-3 px-4'>
																	{index + 1}
																</Td>
																<Td width='10%' className='py-3 px-4'>
																	{keyData === 'department' ? `${user.percentageOfCompletion || '-'}%` : user.tokenNumbers?.[keyData]}
																</Td>
																<Td width='10%' className='py-3 px-4'>
																	{new Date(user.createdOn).toDateString()}
																</Td>
																<Td width='10%' className='py-3 px-4 font-medium'>
																	{user.name}
																</Td>
																<Td width='10%' className='py-3 px-4'>
																	{user.phoneNumber}
																</Td>
																<Td width='10%' className='py-3 px-4'>
																	{keyData === 'rejected' ? (
																		<Button
																			type='delete'
																			onClick={() => {
																				setState({
																					...state,
																					deleteVerificationProcess: true,
																					studentId: user.id || user._id,
																				});
																			}}
																			className='btn btn-danger no-print'>
																			Delete
																		</Button>
																	) : (
																		`${user.shortName}`
																	)}
																</Td>
																<Td width='10%' className='py-3 px-4'>
																	<Button
																		type='save'
																		onClick={() => {
																			let updatedItems;

																			if (keyData === 'fees') {
																				updatedItems = {
																					...itemsData,
																					feesBilling: true,
																					studentId: user.id || user._id,
																				};
																			} else if (keyData === 'pta') {
																				updatedItems = {
																					...itemsData,
																					feesBilling: true,
																					keyDataIsStaff: true,
																					studentId: user.id || user._id,
																				};
																			} else {
																				updatedItems = {
																					feesBilling: true,
																					ptaVerification: true,
																					keyDataIsStaff: true,
																					studentId: user.id || user._id,
																				};
																			}

																			setItemsData(updatedItems);

																			if (keyData === 'pta' || keyData === 'fees') {
																				setShowFeesBilling(true);
																			} else {
																				setState((prev) => ({
																					...prev,
																					verificationProcess: true,
																					studentId: updatedItems.studentId,
																					currentKeyData: keyData,
																				}));
																			}
																		}}>
																		Start Procedure
																	</Button>
																</Td>
																<Td width='10%' className='py-3 px-4'>
																	<Button
																		type='save'
																		onClick={() =>
																			setPrintercustom({
																				visible: true,
																				studentId: user._id,
																				isTemp: user.isTemp || false,
																			})
																		}>
																		Print Forms
																	</Button>
																</Td>
															</Tr>
														))
													)}
												</div>
											)}
										</Tbody>
									</Table>
								</div>
							)}
						</div>
					</div>

					{keyData === 'admDash' && (
						<div className='fixed inset-0 z-50 bg-black/50 flex justify-center items-center'>
							<div className='relative bg-white rounded-xl w-full max-w-5xl p-4 shadow-lg max-h-[90vh] overflow-y-auto'>
								<AdmissionRegister3 onClose={() => setKeyData('')} />
							</div>
						</div>
					)}
				</div>

				{showFeesBilling && (
					<div className='fixed inset-0 z-50 bg-black/50 flex justify-center items-center'>
						<div className='relative bg-white rounded-xl w-full max-w-5xl p-4 shadow-lg max-h-[90vh] overflow-y-auto'>
							<FeesBilling
								onClose={() => {
									setShowFeesBilling(false);
									setState((prev) => ({
										...prev,
										handleProceed: true,
										studentId: itemsData.studentId,
										currentKeyData: keyData,
									}));
								}}
								keyDataIsStaff={itemsData.keyDataIsStaff}
								setItemsData={setItemsData}
								itemsData={itemsData}
								studentId={itemsData.studentId}
								keyForAdmission={true}
							/>
						</div>
					</div>
				)}

				<Modal show={controlCenterDashboardModal} onHide={handleModalClose}>
					<Modal.Header closeButton>
						<Modal.Title>Statistics</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{/* Total Students for Admission {yearOfLatest}: {dataStatastice?.totalStudents || 0} <br />
						Total Verified Students {yearOfLatest}: {dataStatastice?.totalVerifiedStudents || 0} <br />
						Total Rejected Students {yearOfLatest}: {dataStatastice?.totalRejectedStudents || 0} <br />
						Total Pending Students {yearOfLatest} : {dataStatastice?.totalPendingStudents || 0} <br />	 */}
					</Modal.Body>
				</Modal>
			</Main>

			{state.verificationProcess && <AdmissionVerificationProcess userId={state.studentId} isStudent={true} keyData={state.currentKeyData || keyData} refectData={refetch} previousKeyMap={previousKeyMap} stateData={state} setStateData={setState} toast={toast} onClose={() => setState({ ...state, verificationProcess: false, currentKeyData: null })} />}

			{Printercustom.visible && <Printercustompage userId={Printercustom.studentId} stateData={Printercustom} setStateData={setPrintercustom} toast={toast} onClose={() => setPrintercustom({ ...Printercustom, visible: false })} />}

			{state.addNewUsertoAdmission && <AddNewUsertoAdmission onClose={() => setState({ ...state, addNewUsertoAdmission: false })} />}

			{state.deleteVerificationProcess && <DeleteVerificationProcess userId={state.studentId} isStudent={true} keyData={keyData} refectData={refetch} stateData={state} setStateData={setState} toast={toast} onClose={() => setState({ ...state, deleteVerificationProcess: false })} />}

			{state?.handleProceed && (
				<HandleProceed
					userId={state.studentId}
					isStudent={true}
					keyData={state.currentKeyData}
					stateData={state}
					setStateData={setState}
					toast={toast}
					parentOnClose={''}
					onClose={() => {
						setState({ ...state, handleProceed: false, currentKeyData: null });
					}}
				/>
			)}
		</>
	);
}

export default AdmissionControlCenter;
